// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore, makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import loadAddressFields from "@insite/client-framework/Store/Data/AddressFields/Handlers/LoadAddressFields";
import {
    chain,
    DispatchSetInitialValues,
    ValidateBillingAddress,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetInitialValues";
import SetIsBillingAddressTheSameAsShipping from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetIsBillingAddressTheSameAsShipping";

// XNG-Changes: OOTB bug - WEST-944
// getAddressFieldsDataView before ValidateBillingAddress
const xGetAddressFieldsDataView: typeof ValidateBillingAddress = async ({ dispatch, getState }) => {
    const state = getState();

    if (!getAddressFieldsDataView(state).value) {
        const awaitableLoadAddressFieldData = makeHandlerChainAwaitable(loadAddressFields);
        await awaitableLoadAddressFieldData({})(dispatch, getState);
    }
};

/** XNG-Changes
 * Set isBillingAddressTheSameAsShipping initial = ture
 * in Reducer, Pages/OnePageCheckout/SetInitialValues is set by billTo id === shipTo id
 * so we override it after call this reducer
 */
const XngDispatchSetInitialValues: typeof DispatchSetInitialValues = ({ dispatch }) => {
    dispatch(
        SetIsBillingAddressTheSameAsShipping({
            isBillingAddressTheSameAsShipping: true,
        }),
    );
};

addToChainBefore(chain, ValidateBillingAddress, xGetAddressFieldsDataView);
addToChainAfter(chain, DispatchSetInitialValues, XngDispatchSetInitialValues);
